// extracted by mini-css-extract-plugin
export default {"container":"DiscoverJobs_container__8xM4j","btnContainer":"DiscoverJobs_btnContainer__Q60hG"};